export function cloneSlice(slice) {
    return {
        gridSize: slice.gridSize,
        data: slice.data.slice(0),
        pos: { x: slice.pos.x, y: slice.pos.y },
        selected: slice.selected,
        move: { x: slice.move.x, y: slice.move.y },
        hidden: slice.hidden,
        cellSize: slice.gridSize,
    };
}
